import React, { forwardRef } from 'react';
import { Button, Dialog, Typography, Slide, Box } from '@mui/material';

export default function ErrorDialog({ onClose, errorCode }) {
  const Transition = forwardRef((props, ref) => (
    <Slide direction="up" ref={ref} {...props} />
  ));

  return (
    <Dialog fullScreen open={true} TransitionComponent={Transition}>
      <Box
        sx={{
          textAlign: 'center',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box sx={{ maxWidth: 800 }}>
          <Typography variant="h5" gutterBottom={true}>
            {`We're sorry, but we encountered an unexpected error. Please try refreshing the page. If the problem continues contact support and reference error code `}
            <Box
              component="span"
              sx={{
                fontFamily: 'monospace',
                display: 'inline-block',
                fontWeight: 'bold',
              }}
            >
              {errorCode}
            </Box>
          </Typography>
          <Button variant="contained" color="primary" onClick={onClose}>
            Close
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}
